// extracted by mini-css-extract-plugin
module.exports = {"summary":"summary_summary_2Eh7u","content":"summary_content_m79xp","bind":"summary_bind_plM3n"};